import EventEmitter from './EventEmitter';
export default class Sizes extends EventEmitter {
    constructor() {
        super();
        this.resizeTimeout = null;
        // Setup
        this.width = window.innerWidth;
        this.height = window.innerHeight;
        this.pixelRatio = Math.min(window.devicePixelRatio, 2);
        // Detect if mobile device
        this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        // Resize event - ignore on mobile to prevent zoom-triggered re-renders
        window.addEventListener('resize', () => {
            // Skip resize handling on mobile devices
            if (this.isMobile) {
                return;
            }
            this.width = window.innerWidth;
            this.height = window.innerHeight;
            this.pixelRatio = Math.min(window.devicePixelRatio, 2);
            this.trigger('resize');
        });
    }
}
